import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import funzoneWordmarkLightmode from '../../../assets/logos/funzone_wordmark_lightmode.webp';
import funzoneWordmarkDarkmode from '../../../assets/logos/funzone_wordmark_darkmode.webp';

const FunZoneLogo = ({ className, style }) => {
  const theme = useTheme();
  // The brand artwork is transparent, so the ink has to follow the color mode
  const logoSrc =
    theme.palette.mode === 'light' ? funzoneWordmarkLightmode : funzoneWordmarkDarkmode;
  return (
    <Link to='/' style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
      <Box
        component='img'
        src={logoSrc}
        alt='Logo FunZone Erlebniswelten'
        className={className}
        sx={{
          width: '100%',
          maxWidth: '400px',
          minWidth: '100px',
          display: 'block',
          margin: '10px auto',
          ...style,
        }}
        loading='lazy'
      />
    </Link>
  );
};

export default FunZoneLogo;
